module.exports = __webpack_public_path__ + "02_short_gray.1b123fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_short_gray.png
// module id = msf4
// module chunks = 0